import React from 'react';
import { Phone, Mail } from 'lucide-react';

interface FooterProps {
  setCurrentPage: (page: string) => void;
}

const Footer: React.FC<FooterProps> = ({ setCurrentPage }) => {
  return (
    <footer className="bg-purple-700 text-white py-12">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">The Grace Technologies</h3>
            <p className="text-sm">Secured with Grace</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><button onClick={() => setCurrentPage('services')}>Services</button></li>
              <li><button onClick={() => setCurrentPage('about')}>About Us</button></li>
              <li><button onClick={() => setCurrentPage('contact')}>Contact</button></li>
              <li><button onClick={() => setCurrentPage('blog')}>Blog</button></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li>Strategic Security</li>
              <li>Threat Management</li>
              <li>Cloud Security</li>
              <li>Compliance Services</li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-2">
              <p className="flex items-center"><Phone size={16} className="mr-2" /> +1 (555) 123-4567</p>
              <p className="flex items-center"><Mail size={16} className="mr-2" /> contact@gracetech.com</p>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-600 text-center">
          <p>&copy; 2024 The Grace Technologies. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; // Added default export